<template>
	<div style="position: relative;">
		<div v-if="shouye_flag" style="min-height: 100vh;padding-bottom: 70px;box-sizing: border-box;" class="bg">
			<div style="text-align: center;">
				<div>
					<img src="../assets/shouye/title.png" style="width: 60%;padding-top: 15px;"/>
				</div>
				<div>
					<img src="../assets/shouye/jp.png" style="width: 85%;padding-top: 5px;"/>
				</div>
				<div class="jindu">
					<div style="width: 0;flex: 1;position: relative;padding-right: 30px;box-sizing: border-box;">
						<div style="position: relative;">
							<van-progress pivot-text=" " color="#fcb769" :percentage="score/30*100" />
							<img v-if="score/30<0.166" class="jpimg" :src="jp1_2" style="left: 16.6%;"/>
							<img v-else class="jpimg" :src="jp1_1" style="left: 16.6%;"/>
							<img v-if="score/30<0.5" class="jpimg" :src="jp2_2" style="left: 50%;"/>
							<img v-else class="jpimg" :src="jp2_1" style="left: 50%;"/>
							<img v-if="score/30<1" class="jpimg" :src="jp3_2" style="left: 100%;"/>
							<img v-else class="jpimg" :src="jp3_1" style="left: 100%;"/>
						</div>
					</div>
					<img v-if="score<30" :src="dh1" style="width: 60px;"/>
					<img v-else :src="dh2" style="width: 60px;" @click="duihuan"/>
				</div>
				<div style="display: flex;justify-content: center;margin-top: 10px;">
					<div class="yydiv">
						<img src="../assets/shouye/yy.png"/>
						<div>{{exchangenum}}</div>
						<img src="../assets/shouye/400ren.png"/>
					</div>
				</div>
				<div style="position: relative;font-size: 0;width: 60%;margin: 0 auto;margin-top: 20px;">
					<img @click="ljtz" src="../assets/shouye/ljtz.png" style="width: 100%;"/>
					<div style="position: absolute;top: 50%;left: 85%;font-size: 2.2rem;font-weight: bolder;color: #fff;transform: translateY(-50%);">
						<div>{{gamenum}}</div>
					</div>
				</div>
				<div style="display: flex;align-items: center;justify-content: center;margin-top: 20px;">
					<img  @click="wdkf" src="../assets/shouye/wdkf.png" style="width: 38%;margin-right: 5%;"/>
					<img @click="rwzx" src="../assets/shouye/rwzx.png" style="width: 38%;"/>
				</div>
				<div style="margin-top: 15px;">
					<img src="../assets/shouye/yxgl.png" style="width: 85%;"/>
				</div>
			</div>
			
			<img src="../assets/logo.png" class="logo"/>
			<img @click="gz_flag=true" src="../assets/shouye/gz_btn.png" style="width: 35px;position: fixed;top: 5%;right: 0;"/>
		</div>
		<div v-if="qrcode_flag" style="position: fixed;top: 0;left: 0;width: 100vw;height: 100vh;background-color: rgba(0,0,0,0.5);">
			<div style="position: absolute;top: 50%;left: 0;width: 100%;text-align: center;transform: translateY(-50%);">
				<img src="../assets/kefu/code.png" style="width: 80%;"/>
				<img src="../assets/kefu/kfsm.png" style="width: 60%;"/>
				<br />
				<img @click="qrcode_flag=false" src="../assets/fhsy.png" style="width: 40%;margin-top: 30px;"/>
			</div>
		</div>
		<van-popup v-model="renwu_flag" position="bottom">
			<div style="text-align: center;position: relative;font-size: 0;">
				<img src="../assets/renwu/bg1.png" style="width: 100%;"/>
				<div style="margin-top: -1px;position: relative;">
					<img src="../assets/renwu/bg2.png" style="width: 100%;"/>
					<div class="rwList" style="top: 15%;">
						<div style="width: 50%;text-align: left;">
							<img src="../assets/renwu/1.png" style="width: 90%;"/>
						</div>
						<div class="rwnum">{{gamenum_pic}}/1</div>
						<img @click="liulan" src="../assets/renwu/btn1.png" class="rwBtn"/>
					</div>
					<div class="rwList" style="top: 35%;">
						<div style="width: 50%;text-align: left;">
							<img src="../assets/renwu/2.png" style="width: 70%;"/>
						</div>
						<div class="rwnum">{{gamenum_video}}/2</div>
						<img @click="guankan" src="../assets/renwu/btn2.png" class="rwBtn"/>
					</div>
					<div class="rwList" style="top: 55%;">
						<div style="width: 50%;text-align: left;">
							<img src="../assets/renwu/3.png" style="width: 70%;"/>
						</div>
						<div class="rwnum">{{gamenum_invite}}/3</div>
						<img @click="get_task_user" src="../assets/renwu/btn3.png" class="rwBtn"/>
					</div>
				</div>
				<img src="../assets/logo.png" class="logo"/>
			</div>
		</van-popup>
		<div v-if="jz_flag" id="jiazai"
			style="position: fixed;top: 0;left: 0;height: 100%;width: 100%;background-color: rgba(0,0,0,0.5);z-index: 9999;">
			<img src="../assets/loading.gif"
				style="width: 30px;position: absolute;top: 45%;left: 50%;transform: translate(-50%);" />
		</div>
		<div v-if="liulan_flag" style="position: fixed;top: 0;left: 0;height: 100vh;width: 100%;z-index: 3000;overflow-y: auto;" class="bg2">
			<div style="text-align: center;padding-top: 70px;padding-bottom: 100px;">
				<!-- <img src="../assets/liulan/liulan.png" style="width: 85%;"/> -->
				<img src="../assets/code.png" style="width: 70%;"/>
				<br />
				<img src="../assets/liulan/wz.png" style="width: 70%;"/>
				<div v-if="!gb_btn" style="display: flex;margin: 0 auto;margin-top: 30px;justify-content: center;">
					<div class="gb_btn"><span>{{gb_num}}</span><span>秒后可关闭</span></div>
				</div>
				
				<img v-if="gb_btn" @click="liulan_flag=false" src="../assets/fhsy.png" style="width: 35%;margin-top: 30px;"/>
				
			</div>
			<!-- <img src="../assets/logo.png" class="logo"/> -->
		</div>
		<div v-if="gz_flag" style="position: fixed;top: 0;left: 0;height: 100vh;width: 100%;z-index: 3000;overflow-y: auto;background-color: rgba(0, 0, 0, 0.5);">
			<div style="text-align: center;padding-top: 30px;padding-bottom: 30px;">
				<img src="../assets/shouye/guize.png" style="width: 90%;"/>
				
				<img @click="gz_flag=false" src="../assets/shouye/gz_fhsy.png" style="width: 35%;margin-top: 30px;"/>
			</div>
		</div>
		 <!-- v-if=" v-if="yq_flag"" -->
		<div v-if="yq_flag" style="position: fixed;top: 0;left: 0;height: 100vh;width: 100%;z-index: 3000;background-color: rgba(75, 123, 33, 0.5);">
			<div style="position: absolute;top: 50%;left: 0%;transform: translateY(-50%);width: 100%;">
				<div class="kuang" style="text-align: center;">
					<div>
						<img src="../assets/ndyqm.png" style="width: 40%;"/>
					</div>
					<div class="yqm_div">
						<img src="../assets/srkbg.png" style="width: 100%;"/>
						<div class="yqm_text">{{my_invitecode}}</div>
					</div>
					<div style="margin-top: 20px;">
						<img src="../assets/liucheng.png" style="width: 100%;"/>
					</div>
					<div style="margin-top: 20px;position: relative;font-size: 0;">
						<img src="../assets/shouye/yyq.png" style="width: 70%;"/>
						<div class="zyq_text">{{newusernum}}</div>
						<div class="zyq_text2">{{my_gamenum}}</div>
					</div>
				</div>
				<div class="kuang" style="text-align: center;">
					<div>
						<img src="../assets/txyqm.png" style="width: 40%;"/>
					</div>
					<div style="display: flex;justify-content: center;align-items: center;margin-top: 12px;">
						<input v-model="invitecode" class="yqmInput" type="text"/>
						<img @click="post_task_receive" src="../assets/tj2.png" style="width: 35%;"/>
					</div>
				</div>
				<div style="text-align: center;margin-top: 30px;">
					<img @click="yq_flag=false" src="../assets/fhsy.png" style="width: 35%;"/>
				</div>
			</div>
			
		</div>
		 <!-- v-if="dh_flag" -->
		<div v-if="dh_flag" style="position: fixed;top: 0;left: 0;height: 100vh;width: 100%;z-index: 3000;background-color: rgba(75, 123, 33, 0.5);overflow-y: auto;">
			<div style="width: 100%;padding-top: 10vh;">
				<div style="width: 85%;margin: 0 auto;background-color: rgba(75, 123, 33, 0.7);padding: 20px 30px;box-sizing: border-box;border-radius: 10px;">
					<div class="dh_input_div" style="margin-top: 0;">
						<input type="text" v-model="username" class="dh_input" placeholder="请输入姓名"/>
					</div>
					<div class="dh_input_div">
						<input type="text" v-model="phone" class="dh_input" placeholder="请输入手机号"/>
					</div>
					<div class="dh_input_div">
						<textarea v-model="address" class="dh_input" placeholder="请输入地址" style="height: 100px;padding-top: 5px;"/>
					</div>
					<div style="text-align: center;margin-top: 10px;">
						<img @click="tijiao" src="../assets/shouye/gz_tj.png" style="width: 55%;"/>
					</div>
				</div>
				<div style="text-align: center;margin-top: 30px;">
					<img src="../assets/liulan/code.png" style="width: 60%;"/>
					<img src="../assets/dizhi/dzsm.png" style="width: 55%;"/>
				</div>
			</div>
		</div>
		<div v-if="videoFlag" style="position: fixed;top: 0;left: 0;height: 100vh;width: 100%;background-color: rgba(0, 0, 0, 0.5);z-index: 3000;">
		  <div style="position: absolute;top: 12.5%;width: 100%;height: 75%;left: 0;text-align: center;">
		    <video-player
		        ref="videoPlayer"
		        :options="playerOptions"
		        playsinline
		        webkit-playsinline
		        @ended="playEnd"
		    />
		  </div>
		</div>
		<div v-if="game_flag" style="position: fixed;top: 0;left: 0;height: 100vh;width: 100%;box-sizing: border-box;" class="bg2">
			
			<div ref="topdiv" style="text-align: right;padding-top: 20px;padding-bottom: 10px;">
				<div class="time_bg"><span>00 : </span><span>{{time_num<10?('0'+time_num):time_num}}</span></div>
			</div>
			<div class="dati_bg">
				<div ref="titlediv" style="position: relative;font-size: 0;padding: 20px 0;text-align: center;">
					<img v-if="game_data.length>0" @load="resizeGame" :src="game_data[game_num-1].title_img" style="width: 60%;"/>
				</div>
				
				<div ref="container" :style="'height: '+height+'px;padding-bottom: 20px;box-sizing: border-box;position: relative;'">
					<div v-if="isLoading" class="loading">图片加载中...</div>
					<img
					  v-for="(img, index) in imageList"
					  :key="index"
					  :src="img.src"
					  :style="{
						position: 'absolute',
						left: img.left + 'px',
						top: img.top + 'px',
						width: img.displayWidth + 'px',
						height: img.displayHeight + 'px',
						objectFit: 'contain',
						display: img.showFlag?'':'none'
					  }"
					  @error="handleImageError(index)"
					  @click="clickImg(index,img.src)"
					  
					  :class="img_index==index?'act':''"
					/>
				</div>
			</div>
			<div ref="botdiv" style="text-align: center;padding-top: 20px;">
				<!-- <img src="../assets/game/next.png" style="width: 35%;"/> -->
			</div>
			<div v-if="shibai_flag" style="position: fixed;top: 0;left: 0;height: 100vh;width: 100%;background-color: rgba(0, 0, 0, 0.5);z-index: 3000;">
				<div style="width: 90%;top: 50%;left: 5%;position: absolute;transform: translateY(-50%);">
					<img src="../assets/game/shibai.png" style="width: 100%;"/>
					<img @click="fhzy" src="../assets/game/fhzy.png" style="position: absolute;bottom: 10%;left: 50%;transform: translateX(-50%);width: 45%;"/>
				</div>
				
			</div>
			<!-- chenggong_flag -->
		</div>
		 <!--  -->
		<div v-if="chenggong_flag" style="position: fixed;top: 0;left: 0;height: 100vh;width: 100%;box-sizing: border-box;overflow-y: auto;" class="bg">
			<div style="text-align: center;">
				<div>
					<img src="../assets/shouye/title.png" style="width: 60%;padding-top: 15px;"/>
				</div>
				<div>
					<img src="../assets/game/cgcg.png" style="width: 70%;padding-top: 5px;"/>
				</div>
				<div style="background-color: rgba(255, 255, 255, 0.7);margin: 0 auto;margin-top: 10px;width: 90%;border-radius: 15px;padding: 50px 0;box-sizing: border-box;text-align: center;">
					<!-- <img src="../assets/game/nyjl.png" style="width: 60%;"/> -->
					<div style="color: #5d9721;font-size: 2.5rem;font-weight: bolder;text-shadow: -3px -3px 0 #fff, 3px -3px 0 #fff, -3px 3px 0 #fff, 3px 3px 0 #fff;">
						<span>您已累积</span>
						<span style="margin: 0 10px;">{{score}}</span>
						<span>积分</span>
					</div>
				</div>
				<div style="margin-top: 20px;">
					<img src="../assets/game/jq.png" style="width: 80%;"/>
				</div>
				<div style="color: #f98905;font-size: 25px;font-weight: bolder;text-shadow: -2px -2px 0 #fff, 2px -2px 0 #fff, -2px 2px 0 #fff, 2px 2px 0 #fff;margin-top: 20px;">加油</div>
				<div style="display: flex;justify-content: center;margin-top: 3px;">
					<div class="yydiv2">
						<img src="../assets/shouye/yy.png"/>
						<div>{{exchangenum}}</div>
						<img src="../assets/shouye/400ren.png"/>
					</div>
				</div>
				<div style="padding-bottom: 40px;">
					<img @click="fhzy" src="../assets/game/fhsy.png" style="width: 40%;margin-top: 20px;"/>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	import 'video.js/dist/video-js.css'
	import { videoPlayer } from 'vue-video-player'
	import {
		fwl,
		formal_loginin,
		yr_receive,
		task_videourl,formal_exchange, formal_zjxx, task_show,
		task_pic, task_video, task_receive, task_user,question,formal_receive
	} from "@/api/index";
	import Vue from 'vue';
	import Toast from 'vant/lib/toast';
	import 'vant/lib/toast/style';
	
	import Progress from 'vant/lib/progress';
	import 'vant/lib/progress/style';
	
	import Popup from 'vant/lib/popup';
	import 'vant/lib/popup/style';
	
	Vue.use(Popup);
	Vue.use(Progress);
	Vue.use(Toast);
	
	export default {
		name: 'index',
		components: {
			videoPlayer
		},
		data() {
			return {
				jz_flag: false,
				invitecode:null,
				my_invitecode:null,
				newusernum:null,
				my_gamenum:null,
				
				exchangenum:null,
				gamenum:null,
				
				
				jy_flag:false,
				
				score: 0,
				
				dh1: require("../assets/shouye/dh-h.png"),
				dh2: require("../assets/shouye/dh-l.png"),
				
				jp1_1: require("../assets/shouye/dami1.png"),
				jp1_2: require("../assets/shouye/dami2.png"),
				jp2_1: require("../assets/shouye/mf1.png"),
				jp2_2: require("../assets/shouye/mf2.png"),
				jp3_1: require("../assets/shouye/syy1.png"),
				jp3_2: require("../assets/shouye/syy2.png"),
				qrcode_flag:false,
				renwu_flag:false,
				
				
				liulan_flag: false,
				gb_btn: false,
				gb_num: 15,
				
				videoFlag: false,
				playerOptions:{},
				
				gz_flag: false,
				
				dh_flag: false,
				username: null,
				phone: null,
				address: null,
				
				gamenum_invite:null,
				gamenum_pic:null,
				gamenum_video:null,
				
				yq_flag:false,
				
				shouye_flag:true,
				game_flag:false,
				shibai_flag:false,
				chenggong_flag:false,
				
				height:0,
				
				time_num:15,
				game_num:1,
				game_data:[],
				imageList: [],
				isLoading: false, // 新增：加载状态
				imageSizeCache: {}, // 新增：图片尺寸缓存
				
				right_times:0,
				
				
				gameTimer:null,
				img1:null,
				img2:null,
				img_count:0,
				img_index:null
				
			}
		},

		methods: {
			ljtz(){
				if(this.xiazai()){
					if(this.gamenum>0){
						this.get_question()
					}else{
						Toast('无可用游戏次数');
					}
				}
				
			},
			wdkf(){
				if(this.xiazai()){
					this.qrcode_flag=true
				}
			},
			rwzx(){
				if(this.xiazai()){
					this.renwu_flag=true
				}
			},
			get_task_user(){
				this.jz_flag = true
				let post = {
					"jytoken":tokenss
				}
				post = JSON.stringify(post)
				task_user({
					message: post
				}).then(data => {
					console.log("data",data)
					data = data.data
					if(data.code==1){
						this.my_invitecode = data.data.invitecode
						this.newusernum = data.data.newusernum
						this.my_gamenum = data.data.gamenum
						this.yq_flag = true
					}else{
						Toast(data.data);
					}
					this.jz_flag = false
				}).catch(data => {
					this.jz_flag = false
					Toast('服务器错误，请重试');
					
				})
			},
			get_question(){
				this.jz_flag = true
				let post = {
					"jytoken":tokenss
				}
				post = JSON.stringify(post)
				question({
					message: post
				}).then(data => {
					console.log("data",data)
					data = data.data
					if(data.code==1){
						// this.img_list=data.data
						// game1: require("../assets/game/g1.png"),
						// game2: require("../assets/game/g2.png"),
						// game3: require("../assets/game/g3.png"),
						this.game_data = [
							{
								img_list: [...data.data[0],...data.data[0]].sort(() => Math.random() - 0.5),
								title_img: require("../assets/game/g1.png"),
							},
							{
								img_list: [...data.data[1],...data.data[1]].sort(() => Math.random() - 0.5),
								title_img: require("../assets/game/g2.png"),
							},
							{
								img_list: [...data.data[2],...data.data[2]].sort(() => Math.random() - 0.5),
								title_img: require("../assets/game/g3.png"),
							},
						]
						
						this.shouye_flag=false
						
						this.shibai_flag=false
						this.chenggong_flag=false
						this.game_flag = true
						
						this.time_num=15
						this.game_num=1
						this.imageList= []
						this.isLoading= false// 新增：加载状态
						
						this.right_times=0
						this.gameTimer=null
						this.img1=null
						this.img2=null
						this.img_count=0
						this.img_index=null
						this.login()
						this.get_task_show()
						
					}else{
						Toast(data.data);
					}
					this.jz_flag = false
				}).catch(data => {
					this.jz_flag = false
					Toast('服务器错误，请重试');
					
				})
			},
			tijiao(){
				if(!this.username){
					Toast('请输入姓名');
					return
				}
				if(!this.phone){
					Toast('请输入手机号');
					return
				}
				if(!this.address){
					Toast('请输入地址');
					return
				}
				if(!(/^1[3456789]\d{9}$/.test(this.phone))){
					Toast('请输入正确的手机号');
				}
				let post = {
					"jytoken":tokenss,
					"username":this.username,
					"phone":this.phone,
					"address":this.address
				}
				post = JSON.stringify(post)
				this.jz_flag = true
				formal_zjxx({
					message: post
				}).then(data => {
					console.log("data",data)
					data = data.data
					if(data.code==1){
						Toast('提交成功');
						this.dh_flag = false
					}else{
						Toast(data.data);
					}
					this.jz_flag = false
				}).catch(data => {
					this.jz_flag = false
					Toast('服务器错误，请重试');
					
				})
				
			},
			guankan(){
				this.jz_flag = true
				task_videourl({}).then(data => {
					data = data.data
					if(data.code==1){
						this.playerOptions = {
							sources: [{
								src: data.data.videourl,
								type: "video/mp4"
							}],
							autoplay: false,
							controls: true,
							width: "100%",
							height: "75%",
							muted: false,
							loop: false
						}
						
						this.videoFlag = true
						this.$forceUpdate()
						this.$nextTick(()=>{
							setTimeout(()=>{
								this.$refs.videoPlayer.player.play()
							},50)
						})
						
					}else{
						Toast(data.data);
					}
					this.jz_flag = false
				}).catch(data => {
					Toast('服务器错误，请重试');
					this.jz_flag = false
				})
			},
			playEnd(){
				this.videoFlag = false
				this.post_task_video()
			},
			duihuan(){
				this.jz_flag = true
				let post = {
					"jytoken":tokenss
				}
				post = JSON.stringify(post)
				formal_exchange({
					message: post
				}).then(data => {
					console.log("data",data)
					data = data.data
					if(data.code==1){
						this.dh_flag = true
					}else{
						Toast(data.data);
					}
					this.jz_flag = false
				}).catch(data => {
					this.jz_flag = false
					Toast('服务器错误，请重试');
					
				})
				
			},
			liulan(){
				this.liulan_flag = true
				this.gb_num = 15
				this.gb_btn = false
				let djs = setInterval(()=>{
					this.gb_num--
					if(this.gb_num==0){
						clearInterval(djs)
						this.post_task_pic()
						this.gb_btn = true
					}
				},1000)
			},
			post_task_pic(){
				let post = {
					"jytoken":tokenss
				}
				post = JSON.stringify(post)
				task_pic({
					message: post
				}).then(data => {
					console.log("data",data)
					data = data.data
					if(data.code==1){
						Toast('已获取奖励');
						this.login()
						this.get_task_show()
					}else{
						Toast(data.data);
					}
				}).catch(data => {
					Toast('服务器错误，请重试');
					
				})
			},
			post_task_video(){
				let post = {
					"jytoken":tokenss
				}
				post = JSON.stringify(post)
				task_video({
					message: post
				}).then(data => {
					console.log("data",data)
					data = data.data
					if(data.code==1){
						Toast('已获取奖励');
						this.login()
						this.get_task_show()
					}else{
						Toast(data.data);
					}
				}).catch(data => {
					Toast('服务器错误，请重试');
					
				})
			},
			post_task_receive(){
				if(!this.invitecode){
					Toast('请填写邀请码');
				}
				this.jz_flag = true
				let post = {
					"jytoken":tokenss,
					invitecode:this.invitecode
				}
				post = JSON.stringify(post)
				task_receive({
					message: post
				}).then(data => {
					console.log("data",data)
					data = data.data
					if(data.code==1){
						Toast('已获取奖励');
						this.login()
						this.get_task_show()
					}else{
						Toast(data.data);
					}
					this.jz_flag = false
				}).catch(data => {
					this.jz_flag = false
					Toast('服务器错误，请重试');
					
				})
			},
			xiazai(){
				
				// return true
				var str1 = navigator.appVersion;
				var str2 = navigator.userAgent;
							
				var str = "pdmiryun";
				if (str1.indexOf(str) > -1 || str2.indexOf(str) > -1) {
					return true;
							
				} else {
					var u = navigator.userAgent;
					var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
					
					let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
					if (isIOS) {
						window.location.href = 'https://jiyun-applink.hebyun.com.cn/openLink?ios_schema=jiyun://main/detail?id=06237ffb3fda426e9729abb2afd317b6&contentType=1'
					} else{
						window.location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.hbrb.jiyun&android_schema=jiyun%3A%2F%2Fmain%2Fdetail%3Fid%3D06237ffb3fda426e9729abb2afd317b6%26contentType%3D1%26linkType%3D1"
					}
					
				}
			},
			login(){
				let post = {
					"jytoken":tokenss
				}
				post = JSON.stringify(post)
				formal_loginin({
					message: post
				}).then(data => {
					console.log("data",data)
					data = data.data
					if(data.code==1){
						
						
						this.exchangenum = data.data.exchangenum
						this.gamenum = data.data.gamenum
						this.score = data.data.score>30?30:data.data.score
					}else{
						Toast(data.data);
					}
				}).catch(data => {
					Toast('服务器错误，请重试');
					
				})
			},
			
			get_task_show(){
				let post = {
					"jytoken": tokenss
				}
				post = JSON.stringify(post)
				task_show({
					message: post
				}).then(data => {
					data = data.data
					if(data.code==1){
						// Toast('提交成功');
						this.gamenum_invite = data.data.gamenum_invite
						this.gamenum_pic = data.data.gamenum_pic
						this.gamenum_video = data.data.gamenum_video
					}else{
						Toast(data.data);
					}
				}).catch(data => {
					Toast('服务器错误，请重试');
				})
			},
			resizeGame(){
				this.$nextTick(()=>{
					console.log('ss')
					this.height = window.innerHeight - this.$refs.topdiv.offsetHeight - this.$refs.botdiv.offsetHeight - this.$refs.titlediv.offsetHeight
					this.$nextTick(()=>{
						this.initRandomImages();
						
					})
					
				})
				
			},
			
			async initRandomImages() {
			  try {
				this.isLoading = true;
				const container = this.$refs.container;
				if (!container) return;
				this.imageCount = this.game_data[this.game_num - 1].img_list.length
				this.containerWidth = this.$refs.container.clientWidth
				this.containerHeight = this.$refs.container.clientHeight
				// 1. 计算最优行列数
				const { row, col } = this.calcBestLayout(this.imageCount);
				// 2. 计算每个位置的基础尺寸（无重叠的核心）
				const cellWidth = Math.floor(this.containerWidth / col);
				const cellHeight = Math.floor(this.containerHeight / row);
		
				// 3. 生成所有可用的位置坐标（关键：避免重复）
				const allPositions = [];
				for (let r = 0; r < row; r++) {
				  for (let c = 0; c < col; c++) {
					allPositions.push({ row: r, col: c });
				  }
				}
		
				// 4. 随机打乱位置数组，抽取前N个（N=图片数量）
				const randomPositions = this.shuffleArray(allPositions).slice(0, this.imageCount);
		
				// 5. 处理每张图片
				const imageUrls = this.game_data[this.game_num - 1].img_list.slice(0, this.imageCount);
				const imageList = [];
		
				for (let index = 0; index < imageUrls.length; index++) {
				  const src = imageUrls[index].flowerpic;
				  // 获取图片原始尺寸
				  const { naturalWidth, naturalHeight } = await this.getImageNaturalSize(src);
				  // 获取唯一的位置
				  const { row: posRow, col: posCol } = randomPositions[index];
				  // 计算绝对位置（无重叠）
				  const gap = 5;
				  const left = posCol * cellWidth + gap;
				  const top = posRow * cellHeight + gap;
				  // 计算等比例显示尺寸
				  const { displayWidth, displayHeight } = this.calcImageDisplaySize(
					naturalWidth,
					naturalHeight,
					cellWidth - 2 * gap,
					cellHeight - 2 * gap
				  );
		
				  imageList.push({
					src,
					left,
					top,
					displayWidth,
					displayHeight,
					showFlag:true
				  });
				}
		
				this.imageList = imageList;
			  } catch (error) {
				console.error("图片初始化失败：", error);
			  } finally {
				this.isLoading = false;
				this.gameStart()
			  }
			},
			
			/**
			 * 数组随机打乱（Fisher-Yates 洗牌算法）
			 * @param {Array} array 原数组
			 * @returns {Array} 打乱后的数组
			 */
			shuffleArray(array) {
			  const newArray = [...array];
			  for (let i = newArray.length - 1; i > 0; i--) {
				const j = Math.floor(Math.random() * (i + 1));
				[newArray[i], newArray[j]] = [newArray[j], newArray[i]];
			  }
			  return newArray;
			},
		
			/**
			 * 获取图片原始尺寸（保留之前的正确写法）
			 */
			getImageNaturalSize(src) {
			  if (this.imageSizeCache[src]) {
				return Promise.resolve(this.imageSizeCache[src]);
			  }
		
			  return new Promise((resolve, reject) => {
				const img = new Image();
				img.crossOrigin = "anonymous";
				const timeoutTimer = setTimeout(() => {
				  reject(new Error(`图片加载超时：${src}`));
				}, 10000);
		
				img.onload = () => {
				  clearTimeout(timeoutTimer);
				  const size = {
					naturalWidth: img.naturalWidth,
					naturalHeight: img.naturalHeight,
				  };
				  this.imageSizeCache[src] = size;
				  resolve(size);
				};
		
				img.onerror = () => {
				  clearTimeout(timeoutTimer);
				  const fallbackSize = { naturalWidth: 400, naturalHeight: 300 };
				  this.imageSizeCache[src] = fallbackSize;
				  resolve(fallbackSize);
				};
		
				img.src = src;
			  });
			},
		
			/**
			 * 图片加载失败兜底
			 */
			handleImageError(index) {
			  this.$set(
				this.imageList,
				index,
				{
				  ...this.imageList[index],
				  src: "",
				}
			  );
			},
		
			/**
			 * 计算最优行列数
			 */
			calcBestLayout(count) {
			  const sqrt = Math.sqrt(count);
			  let col = Math.ceil(sqrt);
			  let row = Math.ceil(count / col);
			  if (row * (col - 1) >= count) {
				col -= 1;
			  }
			  return { row, col };
			},
		
			/**
			 * 计算图片等比例显示尺寸
			 */
			calcImageDisplaySize(naturalWidth, naturalHeight, maxWidth, maxHeight) {
			  const ratio = Math.min(maxWidth / naturalWidth, maxHeight / naturalHeight);
			  return {
				displayWidth: Math.floor(naturalWidth * ratio),
				displayHeight: Math.floor(naturalHeight * ratio),
			  };
			},
			
			// time_num 
			gameStart(){
				
				
				this.gameTimer = setInterval(()=>{
					this.time_num--
					if(this.time_num==0){
						this.gameOver()
					}
				},1000)
			},
			gameOver(){
				clearInterval(this.gameTimer)
				this.gameTimer = null
				this.shibai_flag = true
				// alert('失败')
				
			},
			clickImg(index,src){
				console.log("index,src",index)
				if(this.img_index==null){
					//第一次进来
					this.img_index = index
					this.img1 = src
				}else{
					//第二次进来
					if(index==this.img_index){
						//取消选中
						
					}else{
						if(this.img1==src){
							//选对了
							this.imageList[this.img_index].showFlag = false
							this.imageList[index].showFlag = false
							this.right_times++
							didi.play()
							if (this.right_times*2==this.game_data[this.game_num - 1].img_list.length) {
								
								if(this.game_num==3){
									//通关
									clearInterval(this.gameTimer)
									this.gameTimer = null
									this.chenggong()
									
								}else{
									//下一关
									this.next()
								}
							}
							
							
						}else{
							//选错了
							this.gameOver()
						}
					}
					this.img_index = null
				}
				
			},
			chenggong(){
				this.jz_flag = true
				let post = {
					"jytoken": tokenss
				}
				post = JSON.stringify(post)
				formal_receive({
					message: post
				}).then(data => {
					data = data.data
					if(data.code==1){
						// Toast('提交成功');
						let post = {
							"jytoken":tokenss
						}
						post = JSON.stringify(post)
						formal_loginin({
							message: post
						}).then(data => {
							console.log("data",data)
							data = data.data
							if(data.code==1){
								
								
								this.exchangenum = data.data.exchangenum
								this.gamenum = data.data.gamenum
								this.score = data.data.score>30?30:data.data.score
								this.chenggong_flag = true
							}else{
								Toast(data.data);
							}
						}).catch(data => {
							Toast('服务器错误，请重试');
							
						})
						
					}else{
						Toast(data.data);
					}
					this.jz_flag = false
				}).catch(data => {
					Toast('服务器错误，请重试');
					this.jz_flag = false
				})
			},
			next(){
				this.right_times=0
				clearInterval(this.gameTimer)
				this.gameTimer = null
				this.game_num++
				this.time_num=15
				this.imageList= []
				this.isLoading= false// 新增：加载状态
				
				this.gameTimer=null
				this.img1=null
				this.img2=null
				this.img_count=0
				this.img_index=null
				
			},
			fhzy(){
				this.login()
				this.get_task_show()
				this.game_flag = false
				this.shouye_flag = true
				this.chenggong_flag = false
				this.shibai_flag = false
			}
		},
		mounted() {
			
			if(!tokenss){
				var gettoken = setInterval(()=>{
					if(tokenss){
						clearInterval(gettoken)
						this.login()
					}
				},1000)
			}else{
				this.login()
				this.get_task_show()
			}
			
			fwl()
			document.title = "来冀云识春花，赢游戏，领米面油礼包"
			weixinshare("https://appapi.hebei.com.cn/ljyschyxpro/share.jpg",'来冀云识春花，赢游戏，领米面油礼包',"更多精彩内容，尽在冀云客户端","https://appapi.hebei.com.cn/ljyschyxpro/index");
			
			if (!is_jiyun()) {
				this.jy_flag = false
				let requestData = {
					contentId: '06237ffb3fda426e9729abb2afd317b6', //
					contentType: "1",
					pubTime: "2026-03-12 09:32:01", //
					title: '来冀云识春花，赢游戏，领米面油礼包', //
					url: 'https://jiyun.hebyun.com.cn/pages/2026/03/12/06237ffb3fda426e9729abb2afd317b6.html', //
					siteId: "d78cdde3a4b0443eb8e4398ca4bc6473"
				}
				upData(requestData)
			}else{
				this.jy_flag = true
			}
			
			// this.jy_flag = true
			
			
			
			
		}
	}
</script>

<style scoped="scoped">
	.bg{
		background-image: url(../assets/bg.jpg);
		background-size: 100% 100%;
	}
	.bg2{
		background-image: url(../assets/bg3.jpg);
		background-size: 100% 100%;
	}
	.jindu{
		width: 90%;
		display: flex;
		align-items: center;
		margin-left: 7.5%;
		margin-top: 3px;
	}
	
	.jpimg{
		position: absolute;
		top: 50%;
		height: 38px;
		transform: translate(-50%,-20%);
	}
	.yydiv{
		background-color: rgba(255, 131, 30, 0.6);
		display: flex;
		padding: 5px 10px;
		border-radius: 30px;
		align-items: center;
	}
	.yydiv2{
		display: flex;
		padding: 5px 10px;
		border-radius: 30px;
		align-items: center;
	}
	.yydiv img{
		height: 20px;
	}
	.yydiv div{
		
		color: #f98905;
		font-size: 17px;
		padding: 2px 10px 0;
		font-weight: bolder;
		text-shadow: -1.5px -1.5px 0 #fff, 1.5px -1.5px 0 #fff, -1.5px 1.5px 0 #fff, 1.5px 1.5px 0 #fff;
	}
	.yydiv2 img{
		height: 30px;
	}
	.yydiv2 div{
		
		color: #f98905;
		font-size: 25px;
		padding: 2px 10px 0;
		font-weight: bolder;
		text-shadow: -2px -2px 0 #fff, 2px -2px 0 #fff, -2px 2px 0 #fff, 2px 2px 0 #fff;
	}
	.kuang{
		background-image: url(../assets/kuang.png);
		background-size: 100% 100%;
		margin: 0 auto;
		width: 90%;
		box-sizing: border-box;
		padding: 20px 15px;
		margin-top: 20px;
	}
	.yqm_div{
		position: relative;
		font-size: 0;
		width: 60%;
		margin: 0 auto;
		margin-top: 5px;
		
	}
	.yqm_text{
		position: absolute;top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		font-size: 1.4rem;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: bolder;
	}
	.zyq_text{
		position: absolute;
		top: 20%;
		left: 69%;
		height: 50%;
		font-size: 1.6rem;
		color: #4b7020;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: bolder;
		transform: translate(-50%,-50%);
	}
	.zyq_text2{
		position: absolute;
		top: 85%;
		left: 39.5%;
		height: 50%;
		font-size: 1.6rem;
		color: #4b7020;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: bolder;
		transform: translate(-50%,-50%);
	}
	.yqmInput{
		width: 45%;
		border: none;
		outline: none;
		background-image: url(../assets/srkbg2.png);
		background-size: 100% 100%;
		font-size: 1.4rem;
		height: 45px;
		text-align: center;
		font-weight: bolder;
		margin-right: 15px;
	}
	.logo{
		width: 35%;
		position: absolute;
		bottom: 10px;
		left: 50%;
		transform: translateX(-50%);
	}
	.xiazai{
		width: 80%;
		height: 50px;
		background-color: #ffa31a;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		border-radius: 10px;
		margin: 0 auto;
		margin-top: 40px;
		font-size: 1.3rem;
	}
	.van-popup{
		background-color: rgba(255, 131, 30, 0);
	}
	.rwList{
		position: absolute;
		display: flex;
		width: 75%;
		align-items: center;
		justify-content: space-between;
		left: 12.5%;
	}
	.rwnum{
		color: #98be71;
		font-size: 1.1rem;
		font-weight: bold;
	}
	.rwBtn{
		width: 25%;
	}
	.gb_btn{
		background-color: #fff;
		border-radius: 10px;
		border: 2px solid #a8e9a0; 
		color: #568620;
		font-size: 1.5rem;
		padding: 10px 20px;
		font-weight: bold;
	}
	.dh_input_div{
		width: 100%;
		margin-top: 20px;
	}
	.dh_input{
		background-color: #fff;
		border: none;
		border-radius: 10px;
		height: 45px;
		padding-left: 10px;
		width: 100%;
		color: #000;
		font-size: 1.2rem;
	}
	.dh_input::placeholder{
		color: #868686;
	}
	.time_bg{
		background: linear-gradient(135deg,#ff6f27,#ffd895);
		display: inline-block;
		color: #fff;
		text-shadow: 0 0 1px 5px #ea894f;
		padding: 0px 10px;
		height: 30px;
		font-size: 1rem;
		line-height: 30px;
		border-radius: 6px;
		box-sizing: border-box;
		margin-right: 5%;
	}
	.dati_bg{
		width: 90%;
		margin: 0 auto;
		background-color: rgba(111, 148, 68, 0.7);
		padding: 0px 20px;
		box-sizing: border-box;
		
		border-radius: 10px;
	}
	.loading {
	  position: absolute;
	  top: 50%;
	  left: 50%;
	  transform: translate(-50%, -50%);
	  color: #666;
	}
	.act{
		border: 1px solid #fff;
		box-sizing: border-box;
	}
</style>
